import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { HireOrangeDubaiIcon } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

function Hiretopdevelopers() {
  return (
    <div className="hire_top_developers p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="">
            <h2>
              Hire Top Developers In Dubai For All Your App Development Needs
            </h2>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className=" offset-xl-1 offset-lg-1"
          >
            <p>
              If you're seeking to hire app developers, leverage our offshore
              app development team’s expertise to bring your business idea to
              fruition.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={5} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-android.png"
                    alt="hire_android"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={49}
                    height={59}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire Android
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Experienced Android developers skilled in Kotlin and Node.js,
                  ready to build scalable Android apps tailored to your needs.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-ios.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={51}
                    height={51}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire iOS <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Dedicated iOS developers proficient in iOS Swift and Python,
                  crafting innovative and user-friendly iOS applications.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-react.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={53}
                    height={61}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire React Native <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Top-notch React.js and React Native developers adept at
                  building large-scale, full-stack web applications to drive
                  your business forward.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-angular.png"
                    alt="hire_angular"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={57}
                    height={60}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire AngularJSM
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Expert Angular.js developers crafting enterprise-grade Angular
                  web apps for smooth user experiences and robust
                  functionalities.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-laravel.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={62}
                    height={62}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire Laravel
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Early adopters of Laravel deliver expert solutions tailored to
                  your business needs with precision and expertise.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-flutter.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={47}
                    height={60}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire Flutter
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Top Flutter developers specializing in secure, scalable
                  cross-platform mobile applications for enhanced user
                  engagement.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hiretopdevelopers;
